import React from 'react';
import { Box, IconButton } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { setLanguage } from '../../redux/actions';
import { Languages } from '../common/Texts';
import { FlagES, FlagPT, FlagEN } from './Flags';
import { topbarTokens as t } from './tokens';

const OPTIONS = [
    { value: Languages.es, label: 'Español', Flag: FlagES },
    { value: Languages.pt, label: 'Português', Flag: FlagPT },
    { value: Languages.en, label: 'English', Flag: FlagEN },
];

export default function LanguageSwitcher() {
    const dispatch = useDispatch();
    const current = useSelector((state) => state.user.language);

    return (
        <Box role="group" aria-label="Language" sx={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 0.25,
        }}>
            {OPTIONS.map(({ value, label, Flag }) => {
                const active = current === value;
                return (
                    <IconButton
                        key={value}
                        size="small"
                        onClick={() => dispatch(setLanguage(value))}
                        aria-label={label}
                        aria-pressed={active}
                        title={label}
                        sx={{
                            p: 0.5,
                            borderRadius: `${t.radius.sm}px`,
                            opacity: active ? 1 : 0.45,
                            outline: active ? `2px solid ${t.color.primaryBorder}` : 'none',
                            outlineOffset: 1,
                            transition: 'opacity .15s',
                            '&:hover': { opacity: 1, backgroundColor: t.color.bgSub },
                        }}
                    >
                        <Flag/>
                    </IconButton>
                );
            })}
        </Box>
    );
}
